<template>
  <div>

    <u-modal id="updateServer" link="Изменить сервер" title="Изменить сервер" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event">
      <form @submit.prevent="updateServer">
        <div class="mb-3">
          <label for="serverId">Сервер</label>
          <select name="serverId" class="form-select" id="serverId" v-model="formData.serverId">
            <option v-for="server in servers"
                    :key="server.id"
                    :value="server.id"
            >{{server.name}} [{{server.host}}]</option>
          </select>
        </div>

        <button type="submit" class="btn btn-primary">Сохранить</button>
      </form>
    </u-modal>
    <div class="d-flex">
      <button v-if="servers.length > 0" type="submit" class="btn btn-secondary me-3" @click="openForm">{{(service.serverId) ? 'Изменить' : 'Добавить'}}</button>
      <ServerCreate/>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {useServersStore} from '@/store/servers'
import {useServiceStore} from "@/store/services";
import ServerCreate from "@/components/servers/ServerCreate";

const isModalOpen = ref(false)
const formData = ref({})

const serviceStore = useServiceStore()
const service = computed(() => serviceStore.item)

const serversStore = useServersStore()
const servers = computed(() => serversStore.items)
serversStore.getList()

function openForm() {
  formData.value.serverId = service.value.serverId ?? servers.value[0].id
  isModalOpen.value = true
}

function updateServer() {
  serviceStore.update(service.value.id, formData.value)
  isModalOpen.value = false
}

</script>
